// extracted by mini-css-extract-plugin
export var borderRadius = "_gm-4";
export var large = "_gm-3";
export var logoContainer = "_gm-0";
export var nameLogo = "_gm-2";
export var small = "_gm-1";